import { VStack } from "@chakra-ui/react";
import React from "react";
import AssistancesCard from "../components/dashboard/AssistancesCard";

/**
 * Renders the dashboard page
 * 
 * @returns The dashboard page
 */
const DashboardPage = () => (
  <VStack alignItems={"stretch"} flexGrow={1} gap={"8px"}>
    <AssistancesCard bgGradient={"linear(#000D18 5%, #003444FF 50%, #000D18 95%)"} padding={"30px 50px"} borderRadius={"20px"} flexGrow={1} />
  </VStack>
);

export default React.memo(DashboardPage);
